import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCompanyProfile } from '../../Redux/companySlice';

const CompanyProtectedRoute = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { isAuthenticated, loading, company } = useSelector((state) => state.company);
  const token = localStorage.getItem('token');

  useEffect(() => {
   

    // If we have a token but no company data, fetch the profile
    if (token && !company) {
      dispatch(fetchCompanyProfile());
    }
  }, [dispatch, isAuthenticated, loading, company, token]);

  // Show loading spinner while checking authentication or fetching profile
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  // If not authenticated and no token, redirect to login
  if (!isAuthenticated && !token) {
    return <Navigate to="/company/login" state={{ from: location }} replace />;
  }

  // If we have a token but no company data yet, show loading
  if (token && !company) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  // If authenticated and have company data, render children
  return children;
};

export default CompanyProtectedRoute; 